import React, { useState, useEffect } from "react";
import AdminSidebar from "./AdminSidebar";
import AdminTopBar from "./AdminTopBar";
import { useNavigate } from "react-router-dom";
import api from "./api/axios";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useActivityLogger } from "./hooks/useActivity";

export default function AdminUploadVideo() {
  const navigate = useNavigate();
  const { logAdminActivity } = useActivityLogger();

  // State for the form fields
  const [formData, setFormData] = useState({
    judul: "",
    sumber: "",
    url: "",
    tag: "",
    deskripsi: "",
    category_id: "", // UBAH: dari 'kategori' menjadi 'category_id'
  });

  // State untuk menyimpan list kategori dari API
  const [categories, setCategories] = useState([]);

  // Fetch Kategori saat halaman dimuat
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await api.get("/kategori");
        setCategories(res.data);
      } catch (err) {
        console.error("Gagal mengambil kategori", err);
      }
    };
    fetchCategories();
  }, []);

  // Handle field changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Handle rich text content changes
  const handleQuillChange = (value) => {
    setFormData((prev) => ({
      ...prev,
      deskripsi: value,
    }));
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    const { judul, sumber, url, tag, deskripsi, category_id } = formData;

    // Ensure all required fields are filled
    if (!judul || !sumber || !url || !deskripsi) {
      alert("Harap isi semua field utama.");
      return;
    }

    // Format the tags as an array
    const tagArray = tag.split(",").map((t) => t.trim());

    // Create the payload for the API
    const payload = {
      judul,
      deskripsi,
      sumber,
      tag: tagArray,
      url,
      // UBAH: Kirim category_id jika dipilih
      category_id: category_id ? parseInt(category_id) : 0,
    };

    try {
      const res = await api.post("/youtube/video", payload);

      logAdminActivity(
        "create",
        "create_admin_video",
        "video",
        res.data.ID,
        res.data.judul || "Unknown Video",
        "success",
        "",
        `Admin berhasil mengupload video ${res.data.judul || "Unknown Video"}`
      );
      alert("Video berhasil diupload!");
      navigate("/admin/video");
    } catch (error) {
      console.error("Gagal mengupload video:", error);
      alert("Terjadi kesalahan saat mengupload video: " + error.message);
    }
  };

  return (
    <div className="min-h-screen flex">
      <AdminSidebar />
      <div className="flex-1 p-6 bg-gray-50">
        <AdminTopBar />

        <div className="bg-white p-6 rounded shadow">
          <button
            onClick={() => navigate(-1)}
            className="text-xl text-black font-semibold mb-8"
          >
            &lt; Upload Video
          </button>

          <form
            onSubmit={handleSubmit}
            className="grid grid-cols-1 md:grid-cols-2 gap-4"
          >
            <div>
              <label className="text-sm block mb-1">Judul</label>
              <input
                type="text"
                name="judul"
                placeholder="Judul"
                value={formData.judul}
                onChange={handleChange}
                className="w-full border rounded px-3 py-2 text-sm"
              />
            </div>

            <div>
              <label className="text-sm block mb-1">Sumber</label>
              <input
                type="text"
                name="sumber"
                placeholder="Sumber"
                value={formData.sumber}
                onChange={handleChange}
                className="w-full border rounded px-3 py-2 text-sm"
              />
            </div>

            <div>
              <label className="text-sm block mb-1">URL Video</label>
              <input
                type="text"
                name="url"
                placeholder="URL video"
                value={formData.url}
                onChange={handleChange}
                className="w-full border rounded px-3 py-2 text-sm"
              />
            </div>

            <div>
              <label className="text-sm block mb-1">
                Tag{" "}
                <span className="text-gray-500">(maks. 5, dipisah koma)</span>
              </label>
              <input
                type="text"
                name="tag"
                placeholder="Tag"
                value={formData.tag}
                onChange={handleChange}
                className="w-full border rounded px-3 py-2 text-sm"
              />
            </div>

            {/* Bagian Kategori Dinamis */}
            <div>
              <label className="text-sm block mb-1">Kategori (opsional)</label>
              <select
                name="category_id"
                value={formData.category_id || ""}
                onChange={handleChange}
                className="w-full border rounded px-3 py-2 text-sm"
              >
                <option value="">-- Pilih Kategori --</option>
                {/* Render kategori dari state API */}
                {categories.map((category) => (
                  <option key={category.ID} value={category.ID}>
                    {category.nama_kategori}
                  </option>
                ))}
              </select>
            </div>

            <div className="md:col-span-2">
              <label className="text-sm block mb-1">Deskripsi</label>
              <ReactQuill
                value={formData.deskripsi}
                onChange={handleQuillChange}
                className="w-full border rounded px-3 py-2 text-sm"
              />
            </div>

            <div className="md:col-span-2 flex justify-end">
              <button
                type="submit"
                className="bg-blue-500 text-white px-6 py-2 rounded hover:bg-blue-600"
              >
                Upload
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
